import { makeAutoObservable } from 'mobx'
import { appName } from '../Service/http'

export type StudentType = {
	id_protocols: number
	id_student: number
	fio: string
	s_fio: string
	osnovanie: string
	id_group: number
	p20: string
	p22: string
	id_a_year: number
	id_f_educ: number
	id_faculty: number
	id_rate: number
	id_leave: number
	reference_number: string
	okno_document: string
	AVN_operator: string
	id_okno_document: number
	id_okno_zakaz: number
	id_raion: number
	ispolnitel: string
	years: string
	naznachenie: string
	// status_new:number
}

class Student {
	student: StudentType = {
		id_protocols: 0,
		id_student: 0,
		fio: '',
		s_fio: '',
		osnovanie: '',
		id_group: 0,
		p20: '',
		p22: '',
		id_a_year: 0,
		id_f_educ: 0,
		id_faculty: 0,
		id_rate: 0,
		id_leave: 0,
		reference_number: '',
		okno_document: '',
		AVN_operator: '',
		id_okno_document: 0,
		id_okno_zakaz: 0,
		id_raion: 0,
		ispolnitel: '',
		years: '',
		naznachenie: ''
	}
	photo: string = `${appName}/img/user.png`
	students: StudentType[] = []

	constructor() {
		makeAutoObservable(this)
	}

	newStudents(param: StudentType[]) {
		this.students = param
	}
	newStudent(param: StudentType) {
		this.student = param
	}
	newPhoto(param: string) {
		this.photo = param
	}
}

export const student = new Student()
